import { getQuarter, startOfQuarter, endOfQuarter, endOfYear, startOfMonth, endOfMonth, startOfYear } from "date-fns";

export enum PeriodType {
  CalendaristicYear = "C",
  FiscalYear = "FY",
  Quarter = "Q",
  Month = "M",
}
export class Period {
  year: number = new Date().getFullYear();
  type: PeriodType = PeriodType.CalendaristicYear;
  periodNumber = 1;
  startDate: Date = new Date();
  endDate: Date = new Date();

  public static makePeriod(year: number, type: PeriodType, periodNumber: number): Period {
    let date = new Date(year, 0); // default for PeriodType.CalendaristicYear / FiscalYear

    switch (type) {
      case PeriodType.CalendaristicYear:
        break;
      case PeriodType.FiscalYear:
        break;
      case PeriodType.Month:
        date = new Date(year, periodNumber - 1);
        break;
      case PeriodType.Quarter:
        date = new Date(year, periodNumber * 3 - 3);
        break;
      default:
        break;
    }

    return new Period(date, type);
  }

  public constructor(date: Date, type: PeriodType = PeriodType.CalendaristicYear) {
    this.year = date.getFullYear();
    this.type = type;
    switch (this.type) {
      case PeriodType.CalendaristicYear:
        this.startDate = startOfYear(date);
        this.endDate = endOfYear(date);
        break;
      case PeriodType.FiscalYear:
        this.startDate = startOfYear(date);
        this.endDate = endOfYear(date);
        break;
      case PeriodType.Quarter:
        this.periodNumber = getQuarter(date);
        this.startDate = startOfQuarter(date);
        this.endDate = endOfQuarter(date);
        break;
      case PeriodType.Month:
        this.periodNumber = date.getMonth() + 1;
        this.startDate = startOfMonth(date);
        this.endDate = endOfMonth(date);
        break;
      default:
        break;
    }
  }

  public getValue() {
    const val = this.year.toString();
    let suffix = "";
    switch (this.type) {
      case PeriodType.CalendaristicYear:
        break;
      case PeriodType.FiscalYear:
        suffix = ` ${this.type}`;
        break;
      case PeriodType.Quarter:
        suffix = ` ${this.type}${this.periodNumber}`;
        break;
      case PeriodType.Month:
        suffix = ` ${this.periodNumber < 10 ? "0" : ""}${this.periodNumber}`;
        break;
      default:
        break;
    }

    return val + suffix;
  }

  public get value() {
    return this.getValue();
  }

  public getDate(): Date {
    let date = startOfYear(this.startDate); // default for PeriodType.CalendaristicYear / FiscalYear

    switch (this.type) {
      case PeriodType.CalendaristicYear:
        break;
      case PeriodType.FiscalYear:
        break;
      case PeriodType.Month:
        date = new Date(this.year, this.periodNumber - 1, 1);
        break;
      case PeriodType.Quarter:
        date = new Date(this.year, this.periodNumber * 3 - 3, 1);
        break;
      default:
        break;
    }

    return date;
  }
}

export const getItemPeriodValue = (period: Period | null): string => {
  const aPeriod = new Period(new Date(), period?.type);
  if (period) {
    aPeriod.year = period?.year;
    aPeriod.type = period?.type;
    aPeriod.periodNumber = period?.periodNumber;
  }

  return aPeriod.value;
};
